<template>
    <div class="main-filter">
        <div class="container--main">
            <div class="main-filter--wrap">
                <div class="main-filter--item">
                    <div class="main-filter--inner">
                        <div class="input--wrap">
                            <input v-model="fullText" type="search" @change="filtersChanged" :placeholder="$t('dashboardFilter.fulltextSearchPlaceholder')" class="input">
                            <svg class="input--icon" width="13" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12.66 12.66"><title>Search</title><path d="M5,8.86A3.84,3.84,0,1,1,8.86,5,3.84,3.84,0,0,1,5,8.86Zm2.91.26,3.3,3.3a.83.83,0,0,0,1.17,0l0,0a.83.83,0,0,0,0-1.17l-3.3-3.3A5,5,0,1,0,7.93,9.12Z" transform="translate(0)"/></svg>
                            <svg @click="removeFilter" v-if="fullText != ''" class="input--icon-end" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32.526 32.526"><path d="M32.526 2.828L29.698 0 16.263 13.435 2.828 0 0 2.828l13.435 13.435L0 29.698l2.828 2.828L16.263 19.09l13.435 13.435 2.828-2.828L19.09 16.263z"/></svg>
                        </div>
                    </div>
                    <div class="main-filter--inner">
                        <label for="dashboardFilter_showSelect">{{ $t('dashboardFilter.show') }}</label>
                        <select v-model="showSelect" @change="filtersChanged" id="dashboardFilter_showSelect" class="select">
                            <option value="null">{{ $t('dashboardFilter.showSelect.all') }}</option>
                            <option value="0">{{ $t('dashboardFilter.showSelect.cold') }}</option>
                            <option value="1">{{ $t('dashboardFilter.showSelect.warm') }}</option>
                        </select>
                    </div>
                    <div class="main-filter--inner">
                        <label for="dashboardFilter_dateSelect">{{ $t('dashboardFilter.date') }}</label>
                        <div class="main-filter--date--wrapper">
                            <div class="main-filter--date">
                                <Datepicker v-model="dateFrom" @selected="dateFromChanged" :language="datepickerCs" :calendar-class="'input--date--in input--date--in--left'" :input-class="'input--date'"></Datepicker>
                            </div>
                            -
                            <div class="main-filter--date">
                                <Datepicker v-model="dateTo" @selected="dateToChanged" :language="datepickerCs" :calendar-class="'input--date--in input--date--in--right'" :input-class="'input--date'"></Datepicker>
                            </div>
                        </div>
<!--                        <select v-model="dateSelect" @change="filtersChanged" id="dashboardFilter_dateSelect"  class="select">-->
<!--&lt;!&ndash;                            <option value="24">{{ $t('dashboardFilter.dateSelect.last24hours') }}</option>&ndash;&gt;-->
<!--&lt;!&ndash;                            <option value="48">{{ $t('dashboardFilter.dateSelect.last48hours') }}</option>&ndash;&gt;-->
<!--                            <option value="168">{{ $t('dashboardFilter.dateSelect.lastWeek') }}</option>-->
<!--&lt;!&ndash;                            <option value="720">{{ $t('dashboardFilter.dateSelect.lastMonth') }}</option>&ndash;&gt;-->
<!--                        </select>-->

                    </div>
                </div>

                <button class="main-filter--button main-filter--button--1" @click="exportSelected">Exportovat vybrané</button>
<!--                <div class="main-filter&#45;&#45;item">-->
<!--                    <div class="main-filter&#45;&#45;inner&#45;&#45;last main-filter&#45;&#45;inner">-->
<!--                        <span>Zobrazit v čase</span>-->
<!--                        <Datepicker></Datepicker>-->
<!--                        <Datepicker></Datepicker>-->
<!--&lt;!&ndash;                        <span>{{ lastUpdate|moment()|startOf('hour')|fromNow() }}</span>&ndash;&gt;-->
<!--&lt;!&ndash;                        <button @click="fireRefresh" class="main-filter&#45;&#45;button">&ndash;&gt;-->
<!--&lt;!&ndash;                            <img src="images/icon-reload.svg" alt="">&ndash;&gt;-->
<!--&lt;!&ndash;                        </button>&ndash;&gt;-->
<!--                    </div>-->
<!--                </div>-->
            </div>
        </div>
    </div>
</template>

<script>
  import moment from 'moment';
  import { mapState } from 'vuex';
  import Datepicker from 'vuejs-datepicker';
  import { cs } from 'vuejs-datepicker/dist/locale'
  import { exportMeasuresDevices } from "../../api/export";
  export default {
    name: "DashboardFilter",
    components: {
      Datepicker
    },
    data: function(){
      const from = moment().subtract(14,'days');
      const to = moment();

      return {
        datepickerCs: cs,
        fullText: '',
        showSelect: null,
        dateSelect: 168,
        dateFrom:  from.toDate(),
        dateTo:  to.toDate(),

        dateFromSelected: from,
        dateToSelected: to
      };
    },
    methods: {
      dateFromChanged: function(date){
        this.dateFromSelected = moment(date);

        this.filtersChanged();
      },
      dateToChanged: function(date){
        this.dateToSelected = moment(date);

        this.filtersChanged();
      },
      filtersChanged: function(){
        this.$store.commit('dashboardFilter/setDashboardFilter', {
          fullText: this.fullText, showSelect: this.showSelect, dateFrom: this.dateFromSelected,dateTo: this.dateToSelected
        });

        this.$emit('dashboardFilterChanged');
      },
      removeFilter: function () {
        this.fullText = '';
        this.filtersChanged();
      },
      exportSelected: async function() {
        let deviceIds = [];
        this.$toasted.show('Připravuji export ke stažení.',{type: 'success'});
        for (let i = 0; i < this.currentDashboard.structures.length; i++) {
          if(this.currentDashboard.structures.hasOwnProperty(i)){
            const structure = this.currentDashboard.structures[i];

            for (let j = 0; j < structure.devices.length; j++) {
                if(structure.devices.hasOwnProperty(j)){
                  deviceIds.push(structure.devices[j].id);
                }
            }
          }
        }

        const dateFrom = this.$store.state.dashboardFilter.dateFrom.format('HH:mm DD-MM-YYYY');
        const dateTo = this.$store.state.dashboardFilter.dateTo.format('HH:mm DD-MM-YYYY');
        const accessToken = this.$store.state.user.authTokens.accessToken;
        const devices = deviceIds.join(',');

        const response = await exportMeasuresDevices(accessToken, {devices, dateFrom, dateTo});

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download','export.xlsx');
        document.body.appendChild(link);
        link.click();
      }
    },
    created: function(){
      this.filtersChanged();
    },
    computed: {
      ...mapState('device',['lastUpdate']),
      ...mapState("structure", ["currentDashboard"])
    }
  }
</script>

<style scoped lang="less">
    .main-filter {
        border-top: 0.063rem solid #e4e5ea;
        border-bottom: 0.063rem solid #e4e5ea;
        font-size: 0.75rem;
        font-weight: 400;
        color: fade(#232220, 34);
        margin-bottom: 20px;
        &--wrap {
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
        &--item {
            display: flex;
            &:first-child {
                flex: 1 1 auto;
            }
        }
        &--inner {
            border-left: 0.063rem solid #e4e5ea;
            padding: 0 0 0 17px;
            display: flex;
            align-items: center;
            &:first-child {
                border: none;
                padding: 0;
                width: 264px;
            }
            &--last {
                &:nth-of-type(n) {
                    width: auto;
                }
            }
        }
        &--button {
            background: none;
            border: none;
            padding: 7px;
            margin: 0 -7px 0 0;
            outline: none;
            &--1 {
                background: #2a0f51;
                color: #fff;
                padding: 5px 15px;
                margin: 0;
            }
        }
        &--date {
            &:first-child {
                margin-right: -1px;
            }
            &--wrapper {
                display: flex;
                align-items: center;
                padding: 0 10px;
                margin: 0 1px;
            }
        }
        @media (max-width: 767px) {
            &--item {
                flex-wrap: wrap
            }
            &--inner {
                min-height: 46px;
                position: relative;
                &:nth-of-type(1) {
                    width: 100%;
                    &:before {
                        content: '';
                        position: absolute;
                        bottom: 0;
                        height: 1px;
                        left: -10px;
                        right: -10px;
                        background: #e4e5ea;
                    }
                }
                &:nth-of-type(2) {
                    padding-left: 0;
                    border-left: none;
                }
                &:nth-of-type(3) {
                    padding-left: 10px;
                }
            }
        }
        @media (max-width: 479px) {
            &--item {
                flex-direction: column;
            }
            &--inner {
                border-left: none;
                &:nth-of-type(2) {
                    &:before {
                        content: '';
                        position: absolute;
                        bottom: 0;
                        height: 1px;
                        left: -10px;
                        right: -10px;
                        background: #e4e5ea;
                    }
                }
                &:nth-of-type(3) {
                    padding-left: 0;
                }
            }
        }
    }
</style>
